import { useQuery } from '@tanstack/react-query';
import { loadReleases, type ReleasesResult } from '@/lib/api/releases';
import { useApiBase } from '@/providers/ApiBaseProvider';

/**
 * Loads all releases for the active API base. Resolves with a `source` of
 * `'live'` or `'sample'` so the UI can label the connection honestly. Never
 * rejects on a network/CORS failure — it falls back to sample data instead.
 */
export function useReleases() {
  const { apiBase, apiKey } = useApiBase();

  return useQuery<ReleasesResult>({
    queryKey: ['releases', apiBase, apiKey],
    queryFn: ({ signal }) => loadReleases(apiBase, apiKey, signal),
  });
}
